<div class="table_sec ">
  <div class="row align-items-center g-2 p-2">

    <div class="m-0 p-0 " [ngClass]="searchColClass">
      <div class="input-group">
        <i class="fa fa-search search-icon"></i>
        <input type="search" (input)="applyFilter($any($event.target).value)" [(ngModel)]="searchText"
          class="form-control pl-4 search_input" placeholder="Search...">
      </div>
    </div>

    <!-- <div class="col-2 m-0">
      <div class="ng-select-icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <path d="M5.89575 10.4775H15.8958M3.39575 5.47754H18.3958M8.39575 15.4775H13.3958" stroke="#344054"
            stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <ng-select class="itm_btn" [items]="mainService.codeValueTechObj['RENT008']" placeholder="Filter"
          bindLabel="value" bindValue="code" [(ngModel)]="selectedSort" (change)="applySort()">
        </ng-select>
      </div>
    </div> -->

    <div class="col-2 m-0" *ngIf="buttonObj?.create_btn?.isCreateButton">
      <button type="button" [class.disablebtn]='btndisabled' (click)="openCreat()" class="itm_btn btn add_btn  w-100">
        <!-- <span [innerHTML]="buttonObj?.create_btn?.create_button_icon"></span> {{buttonObj?.create_btn?.create_btn_name}} -->
        <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(buttonObj?.create_btn?.create_button_icon)"></span>
        {{buttonObj?.create_btn?.create_btn_name}}
      </button>
    </div>

    <div class="col-2 m-0" *ngIf="buttonObj?.export_btn?.isExportButton">
      <button type="button" (click)="export()" class="itm_btn btn export_btn  w-100">

        <!-- <span [innerHTML]="buttonObj?.export_btn?.export_button_icon"></span> {{buttonObj?.export_btn?.export_btn_name}} -->
        <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(buttonObj?.export_btn?.export_button_icon)"></span>
        {{buttonObj?.export_btn?.export_btn_name}}

      </button>
    </div>

    <div class="col-2 m-0" *ngIf="buttonObj?.exportall?.isallbtn">
      <button type="button" (click)="exportAll()" class="itm_btn btn export_btn w-100">

        <!-- <span [innerHTML]="buttonObj?.exportall?.export_button_icon"></span> {{buttonObj?.exportall?.export_btn_name}} -->
        <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(buttonObj?.exportall?.export_button_icon)"></span>
        {{buttonObj?.exportall?.export_all_name}}

      </button>
    </div>

  </div>

  <div class="table_container">

    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container *ngFor="let column of tableColumnsName" matColumnDef="{{column.key}}">

        <!-- <ng-container *ngIf="column.key==='action'; else normalHeader"> -->
        <th mat-header-cell *matHeaderCellDef style="text-align: center;" [class.w-12]="column.key === 'action'">
          <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
            <ng-container *ngIf="column.key === 'checkbox'; else normalHeader">
              <input type="checkbox" [checked]="isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" (change)="masterToggle()" />
            </ng-container>
            <ng-template #normalHeader>
              <span style="text-align: left;">{{ column.value || 'N/A' }}</span>

            </ng-template>
          </div>
        </th>

        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <ng-container *ngIf="actionTemplate && column.key=='action'; else otherCell">
            <ng-container *ngTemplateOutlet="actionTemplate; context: { $implicit: element }"></ng-container>
          </ng-container>

          <ng-template #otherCell>
            <ng-container *ngIf="statusButtonTemplate && column.isButton;else checkboxCell">
              <ng-container *ngTemplateOutlet="statusButtonTemplate; context: { $implicit: element }"></ng-container>
            </ng-container>
          </ng-template>

          <ng-template #checkboxCell>
            <ng-container *ngIf="column.key === 'checkbox'; else normalCell">
              <input type="checkbox" [checked]="selection.isSelected(element)" (change)="toggleRow(element)" />
            </ng-container>
          </ng-template>

          <ng-template #normalCell>
            <ng-container *ngIf="showTooltip; else noTooltip">
              <span class="custom-tooltip-wrapper" [ngClass]="{ 'tooltip-text-color': column.key=='leaf_cd' }"
                (mouseenter)="showFixedTooltip($event,element)" (mouseleave)="hideFixedTooltip()">
                {{ element[column.key] }}

                <!-- Tooltip container -->
                <ng-container *ngIf="column.key=='leaf_cd'">
                  <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
                </ng-container>
              </span>
            </ng-container>
          </ng-template>


          <ng-template #noTooltip>
            <span>
              {{ element[column.key] }}
            </span>
          </ng-template>

        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
    </table>
    <ng-container *ngIf="dataSource.filteredData.length === 0 && is_response_received">
      <div class="text-center py-4" style="color: #888;">
        No records found
      </div>
    </ng-container>
    <div *ngIf="dataSource.filteredData.length > 0 && is_response_received ">
      <app-paginator #pagination [total_data_length]="total_data_length"
        (sendDataToParent)="sendDataToGrandParent($event)" [currentPage]="currentPage" [datasource]="dataSource"
        [pageSize]="pageSize">
      </app-paginator>
    </div>
  </div>


  <!---------------------------- tooltip for hierarchy start ------------------- -->

  <ng-template #tooltipTemplate>
    <div class="custom-tooltip-box table-responsive">
      <table class="">
        <thead>
          <tr>
            <th>nodetype</th>
            <th>Code</th>
            <th>usercode</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let level of levels; let isLast = last" [class.last-level]="isLast">
            <td>{{ level.nodetype }}</td>
            <td>{{ level.code }}</td>
            <td>{{ level.usercode }}</td>
            <td>{{ level.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-template>


  <!-- ----------------------------tooltip for hierarchy end  ---------------->
</div>